import * as amplitude from "@amplitude/analytics-browser";
import {
  SessionReplayPlugin,
  sessionReplayPlugin,
} from "@amplitude/plugin-session-replay-browser";
import { initAmplitude } from "utils/helpers/amplitude";

export const SESSION_REPLAY_MASK_CLASS = "kayros-replay-mask";

const MASKED_ELEMENTS = [
  "input",
  "textarea",
  "select",
  "[contenteditable]",
  ".ant-select-selection-item",
];

const parsedSampleRate = parseFloat(
  process.env.REACT_APP_AMPLITUDE_SESSION_REPLAY_SAMPLE_RATE,
);
const SAMPLE_RATE = Number.isNaN(parsedSampleRate) ? 1 : parsedSampleRate;

const SESSION_REPLAY_STEP_EVENT = "session_replay_step_viewed";

let plugin = null;
let pluginReady = Promise.resolve();

export const startSessionReplay = () => {
  if (plugin || !initAmplitude()) return;
  plugin = sessionReplayPlugin({
    sampleRate: SAMPLE_RATE,
    forceSessionTracking: true,
    privacyConfig: {
      defaultMaskLevel: "light",
      maskSelector: MASKED_ELEMENTS.map(
        (selector) => `.${SESSION_REPLAY_MASK_CLASS} ${selector}`,
      ),
    },
  });
  pluginReady = amplitude.add(plugin).promise;
};

export const stopSessionReplay = () => {
  if (!plugin) return;
  plugin = null;
  amplitude.remove(SessionReplayPlugin.pluginName);
};

export const trackSessionReplayStep = async (properties) => {
  if (!plugin) return;
  await pluginReady;
  if (!plugin) return;
  amplitude.track(SESSION_REPLAY_STEP_EVENT, properties);
};
